import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const ProfilePage: React.FC = () => {
  const { t } = useTranslation();
  const { user, token, login } = useAuth();
  const [email, setEmail] = useState(user?.email || '');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    try {
      const res = await fetch('/api/user/me', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email, password: password || undefined }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t('update_failed'));
      login(token!, { ...user!, email });
      setMessage(t('profile_updated'));
      setPassword('');
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 32 }}>
      <h2>{t('profile')}</h2>
      <form onSubmit={handleUpdate}>
        <div>
          <label htmlFor="email">{t('email')}</label>
          <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div>
          <label htmlFor="new_password">{t('new_password')}</label>
          <input id="new_password" type="password" value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        {message && <div style={{ color: 'green' }} role="alert">{message}</div>}
        {error && <div style={{ color: 'red' }} role="alert">{error}</div>}
        <button type="submit">{t('update_profile')}</button>
      </form>
    </div>
  );
};

export default ProfilePage; 